import { EMBEDDED_VIDEO_URL_MAX_LENGTH } from 'shared/constants'
import type {
  AudioUploadAttachment,
  PostAttachmentType,
} from 'modules/community/types/post-attachment'
import { AttachmentTypeEnum } from 'modules/community/types/post-attachment'

export const isEmbeddedVideoUrlTooLong = (url: string): boolean =>
  url.length > EMBEDDED_VIDEO_URL_MAX_LENGTH

const FACEBOOK_VIDEO_URL_PATTERN =
  /^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/(?:(?:[^#/?]+\/)?videos\/(?:[^#/?]+\/)?\d+\/?|reel\/\d+\/?|(?:watch\/?|video\.php)\?(?:[^#]*&)?v=\d+(?:&[^#]*)?)(?:[#?].*)?$/i

const SUPPORTED_VIDEO_URL_PATTERNS = [
  /^https?:\/\/(?:(?:(?:www|m)\.)?youtube\.com\/(?:watch\/?\?(?:[^#]*&)?v=[\w-]{11}(?:&[^#]*)?|(?:embed|v|shorts|live)\/[\w-]{11}\/?(?:\?[^#]*)?)|youtu\.be\/[\w-]{11}\/?(?:\?[^#]*)?|(?:www\.)?youtube-nocookie\.com\/embed\/[\w-]{11}\/?(?:\?[^#]*)?)(?:#.*)?$/i,
  FACEBOOK_VIDEO_URL_PATTERN,
  /^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/share\/[rv]\/[\da-z]+\/?(?:[#?].*)?$/i,
  /^https?:\/\/fb\.watch\/[\w-]+\/?(?:[#?].*)?$/i,
  /^https?:\/\/(?:clips\.twitch\.tv\/|(?:www\.)?twitch\.tv\/\w+\/clip\/)(?!embed(?:[#/?]|$))[\w-]+\/?(?:[#?].*)?$/i,
  /^https?:\/\/(?:(?:www\.)?vimeo\.com\/(?:channels\/[^#/?]+\/)?\d+(?:\/[\da-z]+)?|player\.vimeo\.com\/video\/\d+)\/?(?:[#?].*)?$/i,
  /^https?:\/\/(?:[\da-z-]+\.)?(?:wistia\.(?:com|net)|wi\.st)\/(?:(?:medias|m|s)\/[\da-z-]+|embed\/iframe\/[\da-z]+)\/?(?:[#?].*)?$/i,
  /^https?:\/\/(?:www\.)?loom\.com\/(?:share|embed)\/(?:[\da-z-]*-)?[\da-f]{32}\/?(?:[#?].*)?$/i,
]

export const isValidEmbeddedVideoUrl = (url: string): boolean => {
  if (/^https?:\/\/(?:(?:www|m)\.)?facebook\.com\/plugins\/video\.php\?[^#]*(?:#.*)?$/i.test(url)) {
    const href = new URL(url).searchParams.get('href')
    return href !== null && FACEBOOK_VIDEO_URL_PATTERN.test(href)
  }

  return SUPPORTED_VIDEO_URL_PATTERNS.some(pattern => pattern.test(url))
}

export const hasEmbeddedVideoAttachmentUrlTooLong = (
  attachments: PostAttachmentType[] = [],
): boolean =>
  attachments.some(
    attachment =>
      attachment.type === AttachmentTypeEnum.EmbeddedVideo &&
      !!attachment.url &&
      isEmbeddedVideoUrlTooLong(attachment.url),
  )

export const filterNotGalleryAttachments = (
  attachments: PostAttachmentType[] = [],
): Exclude<PostAttachmentType, AudioUploadAttachment>[] =>
  attachments.filter(attachment => attachment.type !== AttachmentTypeEnum.Audio)
